// Convert a #RRGGBB hex to a Tailwind/CSS "H S% L%" triplet string.
export function hexToHslTriplet(hex) {
  if (!hex) return null;
  let c = hex.replace("#", "").trim();
  if (c.length === 3) c = c.split("").map((x) => x + x).join("");
  if (c.length !== 6) return null;
  const r = parseInt(c.slice(0, 2), 16) / 255;
  const g = parseInt(c.slice(2, 4), 16) / 255;
  const b = parseInt(c.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

// pick a readable foreground (black/white) triplet for a given brand hex
export function readableForeground(hex) {
  if (!hex) return "0 0% 100%";
  let c = hex.replace("#", "");
  if (c.length === 3) c = c.split("").map((x) => x + x).join("");
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "222 47% 12%" : "0 0% 100%";
}

export function applyBrandTheme(org) {
  if (!org) return;
  const root = document.documentElement;
  const p = hexToHslTriplet(org.primary_color);
  const s = hexToHslTriplet(org.secondary_color);
  if (p) {
    root.style.setProperty("--brand-primary", p);
    root.style.setProperty("--brand-primary-foreground", readableForeground(org.primary_color));
    root.style.setProperty("--chart-1", p);
    root.style.setProperty("--ring", p);
  }
  if (s) {
    root.style.setProperty("--brand-secondary", s);
    root.style.setProperty("--brand-secondary-foreground", readableForeground(org.secondary_color));
    root.style.setProperty("--chart-2", s);
  }
}
